<template>
  <div id="allTeacher" class="teacher mx-3 mt-5 ">
    <b-row align-content="between" style="padding: 0px 25px 0px 25px;">
      <b-col class="mt-0" cols="12" md="12">
        <div class="d-flex justify-content-between align-items-center w-100">
          <span style="font-weight: bold; font-size: 24px" class="mx-1">
            ผู้สอน
          </span>
          <b-button-group class="button-group-fixed">
            <b-button @click="prevCarousel()" class="carousel-button" style="max-width: 54px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                  <path fill="#B1C0D2"
                    d="M7.94 13.06a1.5 1.5 0 0 1 0-2.12l5.656-5.658a1.5 1.5 0 1 1 2.121 2.122L11.122 12l4.596 4.596a1.5 1.5 0 1 1-2.12 2.122l-5.66-5.658Z" />
                </g>
              </svg>
            </b-button>
            <b-button @click="nextCarousel()" class="carousel-button" style="max-width: 54px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                  <path fill="#B1C0D2"
                    d="M16.06 10.94a1.5 1.5 0 0 1 0 2.12l-5.656 5.658a1.5 1.5 0 1 1-2.121-2.122L12.879 12L8.283 7.404a1.5 1.5 0 0 1 2.12-2.122l5.658 5.657Z" />
                </g>
              </svg>
            </b-button>
          </b-button-group>
        </div>
      </b-col>
 
    </b-row>

    <swiper ref="carousel" @click-slide="handlerSlide" :options="swiperOptions" style="padding: 25px;">
      <swiper-slide v-for="creator in teacherList" class="card-teacher pointer" :key="creator.id"
        @click-slide="teacherDetail(creator.id)"> 
        <div class="row align-items-center flex-column flex-md-row">
  <!-- Avatar -->
  <div class="col-sm-5 text-center text-md-left mb-3 mb-md-0">
    <b-avatar :src="creator.profile_image" size="8rem" class="mx-auto mx-md-3 my-3"></b-avatar>
  </div>

  <!-- Name and Position -->
  <div class="col py-3 d-flex flex-column justify-content-center pl-md-0 text-center text-md-left">
    <div class="mb-2 px-2">
      <span style="color: #374151;" class="font-weight-bold text-ellipsis-1-lines">
        {{ creator.first_name + " " + creator.last_name }}
      </span>
    </div>
    <div class="px-2">
      <span style="font-size: 14px; color: #929BAB;">
        {{ creator.teacher_position }}
      </span>
    </div>
  </div>
</div>

      </swiper-slide>
    </swiper>


  </div>
</template>
<script>
import img from "../assets/image/mock/no-image.png";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import { Carousel, Slide } from "vue-carousel";
// import VueSlickCarousel from "vue-slick-carousel";
import { mapState } from "vuex";
// import Search from "@/components/search";

export default {
  name: "Creator",
  props: {
    dataCreator: null,
  },
  computed: {
    ...mapState({
      // teacherList: (state) => {
      //   return state.Teachers.teachersList;
      // },
    }),
  },
  async created() {
    await this.getContent();
  },
  data() {
    return {
      teacherList: [],
      swiperOptions: {
        breakpoints: {
          // when window width is >= 320px
          1400: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 480px
          576: {
            slidesPerView: 1,
            spaceBetween: 30,
            height: 600,
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      },
      indexCarousel: 0,
      isShowCreator: true,
      img: img,
      settings: {
        focusOnSelect: false,
        arrows: false,
        infinite: false,
        // "initialSlide": 2,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        // "autoplay": true,
        ltr: true,
        // "autoplaySpeed": 3000,
        cssEase: "linear",
        variableWidth: true,
        responsive: [
          {
            breakpoint: 2560,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              // "centerMode": true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 375,
            settings: {
              // centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  components: {
    // VueSlickCarousel,
    // Search,
    // Carousel,
    // Slide,
  },
  methods: {
    // endSlide(object) {
    // },
    handlerSlide(object) {
      const teacher = this.teacherList[object];
      this.teacherDetail(teacher.id);
    },
    prevCarousel() {
      this.$refs.carousel.$swiper.slidePrev();
    },
    nextCarousel() {
      this.$refs.carousel.$swiper.slideNext();
    },
    async searchTeacherHandler(text) {
      await this.$emit("search", text);
      this.indexCarousel += 1;
      this.$forceUpdate();
    },
    async getContent() {
      // await this.$store.dispatch("Teachers/TeachersList");
      this.teacherList = await this.$store.dispatch(
        "Teachers/getIndexTeachers"
      );

    },
    async teacherDetail(id) {
      let path = `/teacher-detail`;
      await this.$router.push({
        path: path,
        query: { id: id },
      });
    },
  },
  mounted() {
    this.prevCarousel(); // หรือ nextCarousel() ตามที่ต้องการ
  }
};
</script>
<style lang="scss">
#allTeacher {

  .slick-arrow.slick-next,
  .slick-arrow.slick-prev {
    z-index: 999;
    color: #000000;
    border-color: #000000;
    background-color: transparent;
    /* margin-left: 50px;
    margin-right: 50px; */
  }

  .btn-info {
    background: #3895E7;
  }

  .btn-info:hover {
    background: #1070c4;
  }
}

.card-teacher {
  transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #EBEDF0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  /* เงาปกติ */
}

/* Hover effect: scale + border-color */
.card-teacher:hover {
  transform: scale(1.05);
  border: 1px solid #135193;
  box-shadow: 0 2px 6px #135193;
  /* เปลี่ยนสีเงาเป็นสีเข้ม */
}

.text-ellipsis-1-lines {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%
}

 

.carousel-button{
  background-color: white !important;
  color: #B1C0D2 !important;
  border-color: white !important;
}
 
.carousel-button:hover {
  background-color: #0255A5 !important; /* or use the actual bg-main color code */
  color: white;
}
</style>
